import { useNavigate } from "react-router-dom";
import { DrawerFormLayout } from "@layouts/DrawerFormLayout/DrawerFormLayout";
import {
  ADD_PORTFOLIO_ROUTES,
  BASE_PORTFOLIOS_PATH,
} from "@routing/Portfolios";
import { PropsWithChildren } from "react";

const drawerNavigationItems = [
  {
    name: "Configuration",
    path: ADD_PORTFOLIO_ROUTES.CONFIGURATION,
  },
];

export function AddPortfolioLayout({ children }: PropsWithChildren) {
  const navigate = useNavigate();

  const onClose = () => {
    navigate(`/${BASE_PORTFOLIOS_PATH}`);
  };

  return (
    <DrawerFormLayout
      canGoBack={false}
      drawerNavigationItems={drawerNavigationItems}
      isBackButtonDisabled={false}
      onClose={onClose}
      title="Add new Portfolio">
      {children}
    </DrawerFormLayout>
  );
}
